"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonStyles = void 0;
var commonStyles = function (theme) { return ({
    root: {
        width: '100%',
        display: 'inline-block',
    },
    timeInput: {
        width: 60,
        marginLeft: 8,
    },
    calendarIcon: {
        marginTop: -1,
    },
    paper: __assign(__assign({}, theme.mixins.paper), { padding: 16, paddingBottom: 12, display: 'inline-block', margin: '4px 0px' }),
}); };
exports.commonStyles = commonStyles;
